export default "__VITE_ASSET__cdeef517__"